import React, {useState} from "react";
import ImageInput from "../../Components/Inputs/ImageInput";
import TextInput from "../../Components/Inputs/TextInput";

export default function ({register, errors, control}) {

  const [customErrors, setCustomErrors] = useState({});

  const checkDimensions = (imgUrl, name, width, height) => {

    let img = new Image();

    img.src = URL.createObjectURL(imgUrl);
    let tempErrors = customErrors;

    img.onload = function() {
      let errText = '';
      if((this.width != width) || (this.height != height)){
        errText = 'Incorrect resolution';
      }
      tempErrors[name] = errText;
      setCustomErrors({...tempErrors})
    };
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-around gap-1 mb-3">
        <div className='w-50'>
          <ImageInput
            label='Desktop image (1366x768 px)'
            name='desktop_image'
            control={control}
            errorMessage={errors?.desktop_image}
            parentClasses="col-xl-4 col-sm-12"
            classes="d-inline-block"
            id='desktop_image'
            callback={
              (img) => checkDimensions(img, `desktop_image`, 1366, 768)
            }
          />
          <div className="fv-plugins-message-container invalid-feedback mb-4">
            <div>{customErrors?.['desktop_image']}</div>
          </div>
        </div>
        <div className='w-50'>
          <ImageInput
            label='Mobile image (360x760 px)'
            name='mobile_image'
            control={control}
            errorMessage={errors?.mobile_image}
            parentClasses="col-xl-4 col-sm-12"
            classes="d-inline-block"
            id='mobile_image'
            callback={
              (img) => checkDimensions(img, `mobile_image`, 360, 760)
            }
          />
          <div className="fv-plugins-message-container invalid-feedback mb-4">
            <div>{customErrors?.['mobile_image']}</div>
          </div>
        </div>
      </div>

      <TextInput
        label='Url'
        name='url'
        register={register}
        errorMessage={errors?.url}
      />

      <TextInput
        label='Position'
        name='position'
        register={register}
        errorMessage={errors?.position}
        type='number'
      />
    </>
  );
}